import { graphql } from 'react-relay';

import { useMutationInterop } from '@confluence/apollo-relay-interop';

import type {
	useSetContentGeneralAccessModeMutation$data as MutationData,
	useSetContentGeneralAccessModeMutation$variables as MutationVariables,
} from './__generated__/useSetContentGeneralAccessModeMutation.graphql.ts';

export const setContentGeneralAccessModeMutation = graphql`
	mutation useSetContentGeneralAccessModeMutation(
		$cloudId: ID!
		$input: ConfluenceSetContentGeneralAccessModeInput!
	) {
		confluence_setContentGeneralAccessMode(cloudId: $cloudId, input: $input) {
			contentGeneralAccess {
				mode
			}
			success
			errors {
				message
			}
		}
	}
`;

export function useSetContentGeneralAccessMode() {
	return useMutationInterop<MutationData, MutationVariables>(setContentGeneralAccessModeMutation);
}
